import { get } from '../client'

const abilityClient = {
  getAll: async () => {
    return (await get('/api/abilities')).abilities
  }
}

export { abilityClient }
